import { TranslationDictionary } from '@delen/connect-core';

type TranslationJSON = { [key: string]: string };

const enGB: TranslationJSON = require('./en-GB.json');
const nlBE: TranslationJSON = require('./nl-BE.json');
const frBE: TranslationJSON = require('./fr-BE.json');
const nlNL: TranslationJSON = require('./nl-NL.json');

TranslationDictionary.setStrings('en-GB', enGB);
TranslationDictionary.setStrings('nl-BE', nlBE);
TranslationDictionary.setStrings('fr-BE', frBE);
TranslationDictionary.setStrings('nl-NL', nlNL);
